import { Table, Thead, Tbody, Tr, Th, Td, Box, Text } from '@chakra-ui/react';

export const PropsTable = () => {
	return (
		<Box my="20px">
			<Text fontSize="2xl" my="20px">
				Props
			</Text>
			<Table size="md" border="1px" borderColor="gray">
				<Thead>
					<Tr>
						<Th>Prop</Th>
						<Th>Description</Th>
						<Th>Default</Th>
					</Tr>
				</Thead>
				<Tbody>
					<Tr>
						<Td>value: number</Td>
						<Td>Number in percentage showing current progress</Td>
						<Td>0</Td>
					</Tr>
					<Tr>
						<Td>options</Td>
						<Td>Progress Bar Options to help you customize </Td>
						<Td />
					</Tr>
				</Tbody>
			</Table>
		</Box>
	);
};
